define('app/directives/file_read',['angular', 'app/services/shared'], function (angular) {
  var module = angular.module('app.fileread', ['app.shared'])

  module.directive("fileread", [function () {
    return {
        scope: {
            fileread: "="
        },
        link: function (scope, element, attributes) {
            element.bind("change", function (changeEvent) {
                var reader = new FileReader();
                reader.onload = function (loadEvent) {
                    scope.$apply(function () {
                        scope.fileread = loadEvent.target.result;
                    });
                }
                reader.readAsText(changeEvent.target.files[0]);
            });
        }
    }
  }]);
  
  return module;
})
;
